var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dv-border-box-12',{staticClass:"padding-lr-sm padding-bottom-lg margin-top-xs dayTimeBox"},[_c('SecondTitle',{staticClass:"margin-bottom-xs",attrs:{"secTitle":_vm.secTitle}}),_c('Chart',{attrs:{"cdata":_vm.cdata,"width":'500',"height":'190'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }